import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', loadComponent: () => import('./feature/home/home.component').then(m => m.HomeComponent) },
    { path: 'new-hydrotest', loadComponent: () => import('./feature/new-hydrotest/new-hydrotest.component').then(m => m.NewHydrotestComponent) },
    { path: 'search-database', loadComponent: () => import('./feature/search-database/search-database.component').then(m => m.SearchDatabaseComponent) },
    { path: 'search-database/details', loadComponent: () => import('./feature/search-database/search-details/search-details.component').then(m => m.SearchDetailsComponent) },
    { path: 'error', loadComponent: () => import('./feature/error-page/error-page.component').then(m => m.ErrorPageComponent) },
    { path: 'admin', loadComponent: () => import('./feature/admin/admin.component').then(m => m.AdminComponent) },
    { path: 'admin-update', loadComponent: () => import('./feature/admin/admin-update/admin-update.component').then(m => m.AdminUpdateComponent) },
    // { path: '**', redirectTo: 'home', pathMatch: 'full' }
];
